import { get } from 'es-toolkit/compat';
import * as React from 'react';
import { FieldProps } from 'formik';

import { TextArea } from './TextArea';

interface Props extends FieldProps {
  autoFocus?: boolean;
  className?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  rows?: number;
  onChange?(event: React.ChangeEvent<HTMLTextAreaElement>): void;
  onBlur?(event: React.FocusEvent<HTMLTextAreaElement>): void;
}
/**
 * @deprecated
 * Please see ui folder of your project under forms,
 * FormTextField, and TextField, multiline prop
 * https://material-ui.com/components/text-fields/#multiline
 *
 * OLD:
 * Use `FormikTextArea` to have a textarea field in a formik based form. .
 *
 * ```js
 * import { FormikTextArea } from '.';
 * ```
 */
export class FormikTextArea extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { field, onChange } = this.props;

    field.onChange(event);

    if (onChange) {
      onChange(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { field, onBlur } = this.props;

    field.onBlur(event);

    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      field,
      label,
      className,
      onChange,
      onBlur,
      form: { touched, errors },
      ...props
    } = this.props;

    const hasError = !!(get(touched, field.name) && get(errors, field.name));

    return (
      <TextArea
        label={label}
        hasError={hasError}
        error={get(errors, field.name)}
        className={className}
        {...field}
        {...props}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
